import React from 'react';
import gql from 'graphql-tag';
import { useApolloClient } from '@apollo/client';
import { LoadingSection } from '../../UI';
import { TranslateProvider } from '../../containers/TranslationsProvider';
import CouncilPortalForm from './CouncilPortalForm';
import CreatePortalForm from './CreatePortalForm';
import LoggedLayoutRoot from './LoggedLayoutRoot';

const PortalManager = ({ match }) => {
	const [councilPortal, setCouncilPortal] = React.useState({});
	const [loading, setLoading] = React.useState(true);
	const client = useApolloClient();
	const translate = React.useContext(TranslateProvider);

	const getData = React.useCallback(async () => {
		setLoading(true);
		const response = await client.query({
			query: gql`
	        query CouncilPortal($councilId: Int!){
	            councilPortalByCouncilId(councilId: $councilId){
	                sendAcceptConfirmation
	                sendRefuseConfirmation
	                accessConfirmationText
	                delegationConfirmationText
	                lastEdited
	                refusedConfirmationText
	                name
	                id
	                config
	                state
	                attachments {
	                    id
	                    filename
						showInHome
	                }
	                council {
	                    name
	                    id
	                    company {
							logo
						}
	                    dateStart
	                    agendas {
							orderIndex
	                        agendaSubject
	                        subjectType
	                        id
	                        items {
	                            id
	                            value
	                        }
	                        options {
	                            maxSelections
	                            minSelections
	                            id
	                        }
	                    }
	                }
	            }
	        }
	    `,
			variables: {
				councilId: parseInt(match.params.id, 10)
			},
		});
		if (response?.data?.councilPortalByCouncilId) {
			setCouncilPortal(response?.data?.councilPortalByCouncilId);
		}
		setLoading(false);
	}, [match.params.id]);


	React.useEffect(() => {
		getData();
	}, [councilPortal]);

	if (loading && !councilPortal?.council) {
		return (
			<LoadingSection />
		);
	}

	if (!councilPortal?.council) {
		return (
			<CreatePortalForm
				match={match}
				translate={translate}
				refetch={getData}
			/>
		);
	}

	return (
		<LoggedLayoutRoot>
			<CouncilPortalForm
				portal={councilPortal}
				translate={translate}
				refetch={getData}
				loading={loading}
			/>
		</LoggedLayoutRoot>
	);
};

export default PortalManager;
